import { render, staticRenderFns } from "./shop-collection.vue?vue&type=template&id=07cc5111&scoped=true"
import script from "./shop-collection.vue?vue&type=script&lang=js"
export * from "./shop-collection.vue?vue&type=script&lang=js"
import style0 from "./shop-collection.vue?vue&type=style&index=0&id=07cc5111&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc5111",
  null
  
)

export default component.exports